/**
 * Het formulier voor een persona: hetzelfde voor een nieuwe en voor het
 * bewerken van een bestaande. Stond twee keer in het beheerpaneel, met
 * net andere velden en labels; nu één keer, met labels.
 *
 * De velden zijn het CV van het personage: wat de leerlingen zien
 * (profiel, korte omschrijving, portret) en wat het model krijgt om het
 * personage te spelen (achtergrond, persoonlijkheid, spreekstijl, de rest).
 */
import React from 'react';
import { Save } from 'lucide-react';
import { basis } from '../stijlen';
import { PortretKiezer } from './PortretKiezer';

export const LEGE_PERSONA = {
  naam: '', korte_omschrijving: '', profiel: '', portret: '', geslacht: '', leeftijd: '', geboorteplaats: '',
  woonplaats: '', samenlevingsvorm: '', werk: '', opleiding: '', inkomenspositie: '', migratieachtergrond: '',
  bijzonderheden: '', achtergrond: '', persoonlijkheid: '', spreekstijl: '', vast_type: '',
};

export const AGENT_ROLLEN = [
  ['discussieleider', 'Discussieleider'], ['kennis_pro', 'Kennis pro'], ['kennis_contra', 'Kennis contra'],
  ['expert_pro', 'Expert pro'], ['expert_contra', 'Expert contra'], ['twijfelaar', 'Twijfelaar'],
  ['echoput', 'Echoput'], ['afleider', 'Afleider'],
];

const CV_VELDEN = [
  ['geslacht', 'Geslacht'], ['leeftijd', 'Leeftijd', 'number'], ['geboorteplaats', 'Geboorteplaats'],
  ['woonplaats', 'Woonplaats'], ['samenlevingsvorm', 'Samenlevingsvorm'], ['werk', 'Werk'],
  ['opleiding', 'Opleiding'], ['inkomenspositie', 'Inkomenspositie'], ['migratieachtergrond', 'Migratieachtergrond'],
];

export function PersonaFormulier({ api, apiUrl, portretten, titel, waarde, onWijzig, onOpslaan, onAnnuleer, onPortretGeupload }) {
  const zet = (veld) => (e) => onWijzig({ ...waarde, [veld]: e.target.value });
  const tekstvak = (veld, label, hoogte = '80px') => (
    <>
      <label style={styles.label}>{label}</label>
      <textarea value={waarde[veld] || ''} onChange={zet(veld)} style={{ ...styles.input, minHeight: hoogte }} />
    </>
  );

  return (
    <form onSubmit={(e) => { e.preventDefault(); onOpslaan(); }} style={styles.editForm}>
      <h2>{titel}</h2>
      <div style={{ height: '12px' }}></div>

      <label style={styles.label}>Naam</label>
      <input type="text" value={waarde.naam || ''} onChange={zet('naam')} style={styles.input} required />

      {tekstvak('profiel', 'Profiel (zichtbaar voor leerlingen)')}

      <label style={styles.label}>Korte omschrijving</label>
      <input type="text" value={waarde.korte_omschrijving || ''} onChange={zet('korte_omschrijving')} style={styles.input} required />

      <PortretKiezer api={api} apiUrl={apiUrl} portretten={portretten} huidig={waarde.portret}
        onKies={(naam) => onWijzig({ ...waarde, portret: naam })} onGeupload={onPortretGeupload} />

      <div style={styles.infoGrid}>
        {CV_VELDEN.map(([veld, label, type]) => (
          <div key={veld}>
            <label style={styles.label}>{label}</label>
            <input type={type || 'text'} value={waarde[veld] || ''} onChange={zet(veld)} style={styles.input} />
          </div>
        ))}
      </div>

      {tekstvak('bijzonderheden', 'Bijzonderheden en interesses', '60px')}
      {tekstvak('achtergrond', 'Waarden & Overtuiging')}
      {tekstvak('persoonlijkheid', 'Persoonlijkheid')}
      {tekstvak('spreekstijl', 'Spreekstijl')}

      <label style={styles.label}>Agent-rol</label>
      <select value={waarde.vast_type || ''} onChange={zet('vast_type')} style={styles.input}>
        <option value="">-- Geen vaste rol --</option>
        {AGENT_ROLLEN.map(([sleutel, naam]) => <option key={sleutel} value={sleutel}>{naam}</option>)}
      </select>
      <div style={{ height: '16px' }}></div>
      <div style={styles.formButtons}>
        <button type="submit" style={styles.saveBtn}><Save size={16} /> Opslaan</button>
        <button type="button" onClick={onAnnuleer} style={styles.cancelBtn}>Annuleren</button>
      </div>
    </form>
  );
}

const styles = { ...basis };
